import TrackerContainer from './TrackerContainer';
import { getIsNewUser, getIsExistingUserSession, getIsNewPortalCreated } from '../store/app/selectors';
import { getAuthState, getIsAuthInitialized, getIsAuthenticated } from '../store/auth/selectors';
import { isPostVerification } from '../flow-settings/settingsSelectors';
const enableTracking = store => {
  const state = store.getState();
  const isNewUser = getIsNewUser(state);
  const isNewPortal = getIsNewPortalCreated(state);
  const isExistingUserSession = getIsExistingUserSession(state);

  // To enable anon tracking at the beginning of the flow
  if (getIsAuthInitialized(state) && !getIsAuthenticated(state) && !isNewPortal && !TrackerContainer.isAnonymousTrackingEnabled && !TrackerContainer.identifiableTrackingEnabled) {
    TrackerContainer.enableAnonTracking();
  }

  // To enable identifiable tracking switching to existing user
  if (!isNewUser && isExistingUserSession && !isPostVerification() && TrackerContainer.isAnonymousTrackingEnabled) {
    const authState = getAuthState(state);
    if (authState.auth) TrackerContainer.switchToIdentifiableTracker(authState.auth.email);
    TrackerContainer.setProperties({
      userId: authState.userId,
      hubId: authState.portalId
    });
  }
};

/**
 * @description Middleware to drain the tracking event queue if
 * - The user accepts the cookie banner
 * - The user provides their email through the form, or through google
 */
export const TrackingQueueDrainingMiddleware = store => next => action => {
  enableTracking(store);
  return next(action);
};